/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
//import Reflux from 'reflux';
import {hashHistory} from 'react-router'
import {Button} from 'antd';
import {DmsTab} from 'Components';
import { detail } from '../../service/info'
import {config} from  'Utils'
import './infodetail.css';

class InfoDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			infoId: parseInt(this.props.params.id, 10),
	  		detail: {},
	  		button_limits_end: {},
		}
	}
	componentDidMount(){
		const self = this;
		detail(this.state.infoId).then(res => {
			if(res.status){
				self.setState({detail: res.data,});
			}
		});
		this.setState({
		      button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
		});
	}
	goView(url) {
		hashHistory.push(url);
	}
  goBack() {
	hashHistory.goBack();
  }
	
	openModal() {
		this.remarkModal.showModal();
	}
	
	render() {
		const {detail, infoId,button_limits_end} = this.state;
		
		return <div className="dms-main-box">
			
			<DmsTab options={['新闻详情']} defaultKey={0}>
				 { button_limits_end.info_detail_02 && <Button onClick={this.goBack}>返回</Button>}
				 { button_limits_end.info_detail_01 && <Button onClick={this.goView.bind(this, `/info/add/${infoId}`)}>编辑</Button>}
			</DmsTab>
			<div className="dms-table-box">
				<div className="main">
					<h1 className='detail_title'>{detail.title}</h1>
					<div className="main_detail">
						<img className="detail_img" alt={`${detail.title}图片`}
								 src={detail.filePath ? `${config.server}${detail.filePath}` : ''}/>
						<div className="message">
							<p className='read'>{`阅读（${detail.clickCount}）`}</p>
							<p className='comment'>评论（<a href={`#/info/${infoId}/comment/list`}>{detail.commentCount}</a>）</p>
						</div>
					</div>
				</div>
				<div className="info_content" dangerouslySetInnerHTML={{__html: detail.content}}></div>
				{(detail.fileUrls || []).length > 0 && (
					<div className="info_attach_list">
						<p>附件：</p>
						{(detail.fileUrls || []).map((item, index) => (
							<p key={item.id || index}>
								<a
									href={`${config.server}${(item.filePath || '').replace('getFile', 'getFileDown')}`}
									download={item.fileName}
									target="_blank"
									rel="noopener noreferrer">
									{item.fileName}
								</a>
							</p>
						))}
					</div>
				)}
			</div>
		</div>
	}
}
;
export default InfoDetail;



// WEBPACK FOOTER //
// ./src/routes/info/detail.js